<div
  class="dl-container"
  role="dialog"
  aria-modal="true"
  aria-labelledby="dl-prompt-title"
>
  <!-- Close — floats over the card corner -->
  <button type="button" class="close-btn" (click)="close()" aria-label="Cerrar">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>

  <img [src]="logoUrl" alt="Art Stgo" class="dl-logo" draggable="false" />

  <h2 id="dl-prompt-title" class="dl-title">Descarga la app Art Stgo</h2>

  <p class="dl-subtitle">
    Accede a más beneficios y noticias de los artistas, y vota en los concursos.
  </p>

  @if (isDesktop) {
    <div class="dl-ctas">
      <button type="button" class="action dl-cta" (click)="download('app-store')">
        <span>App Store</span>
      </button>
      <button type="button" class="action dl-cta" (click)="download('play-store')">
        <span>Google Play</span>
      </button>
    </div>
  } @else {
    <button type="button" class="action dl-cta" (click)="download()">
      <span>Descargar app</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" />
      </svg>
    </button>
  }
</div>
